import {
  List,
  TextField,
  EditButton,
  SimpleList,
  Datagrid,
  FunctionField,
  TopToolbar,
  CreateButton,
} from "react-admin";
import { EmptyList } from "server/components";
import { useMediaQuery } from "@mui/material";
import { getPermissions } from "auth/security/securityUtils";
import { checkPermission } from "server/security/utils";
import permissions from "app/permissions";
import { settings } from "app";
import { INTERNSHIPS, MOBILE_BREAKPOINT } from "utils/constants";
import { EducationsExporter } from "../XlsxExporter";
import { ExportXlsButton } from "features/ExportXlsxButton";
import { MobileListRow } from "features/MobileListRow";

const ListInternships = () => {
  const isMobile = useMediaQuery(MOBILE_BREAKPOINT);
  const userPermissions = getPermissions();

  const internshipsType = {
    1: "Летен",
    2: "Пред-дипломен",
  };

  const ListActions = hasCreate => {
    return (
      <TopToolbar>
        {hasCreate && <CreateButton />}
        <ExportXlsButton exporter={EducationsExporter(INTERNSHIPS)} />
      </TopToolbar>
    );
  };

  return (
    <List
      actions={<ListActions hasCreate={checkPermission(userPermissions, permissions.canCreateInternships)} />}
      title="Списък със стажове"
      sx={settings.style.expandStyle}
    >
      {isMobile ? (
        <SimpleList
          empty={<EmptyList />}
          linkType={false}
          sx={settings.style.mobileList}
          primaryText={record => (
            <MobileListRow fields={[{ label: "Име на български език", value: record.nameBg }]} />
          )}
          secondaryText={record => (
            <div>
              <MobileListRow fields={[{ label: "Име на английски език", value: record.nameEn }]} />
              <MobileListRow fields={[{ label: "Вид стаж", value: internshipsType[record.type] }]} />
            </div>
          )}
          tertiaryText={record => (
            <>{checkPermission(userPermissions, permissions.canUpdateInternships) && <EditButton label="" />}</>
          )}
        />
      ) : (
        <Datagrid
          bulkActionButtons={false}
          rowClick={false}
        >
          <TextField
            source="nameBg"
            label="Име на български език"
            sortable={false}
          />
          <TextField
            source="nameEn"
            label="Име на английски език"
            sortable={false}
          />

          <FunctionField
            label="Вид стаж"
            render={record => internshipsType[record.type]}
          />
          {checkPermission(userPermissions, permissions.canUpdateInternships) && <EditButton />}
        </Datagrid>
      )}
    </List>
  );
};
export default ListInternships;
